import senadoLogo from "@/core/assets/img/cabecalhos-pdf/senado-logo.jpg";
import { obterDataFormatada, obterHoraFormatada } from "../../utils";

export function createHeaderSenado(doc, title) {
  doc.addImage(senadoLogo, "JPEG", 8, 10, 40, 12);
  doc.setFont("", "bold");

  doc.text(title, 52, 17, null, null);
  doc.setFont("", "normal");

  doc.setFontSize(10);
  doc.text(
    "Emitido no dia " + obterDataFormatada() + " as " + obterHoraFormatada(),
    283,
    17,
    null,
    null,
    "right"
  );

  doc.text("Página 1 / 1", 283, 22, null, null, "right");

  return doc;
}
